<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}}</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="handleSubmit()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <TheLoader :active="$store.getters.isFormLoading"/>
    <div v-if="!$store.getters.isFormLoading" class="content-container flex-row">
      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="grid-x grid-padding-x">
              <TheTextInput containerClassName="cell large-13" label="Objektbeskrivelseid" v-model.trim="item.Objektbeskrivelseid" :disabled="true"/>
              <TheTextInput containerClassName="cell large-12" label="Beskrivelse" name="Beskrivelse" v-model.trim="item.Beskrivelse" maxlength="100" required v-validate="'required|max:100'"/>
              <TheTextInput containerClassName="cell large-12" label="Engelsk" name="Engelsk" v-model.trim="item.Engelsk" maxlength="100" v-validate="'max:100'"/>
            </div>
          </fieldset>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'

export default {
  name: 'InstillingerObjektbeskrivelseEdit',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      service: InstillingerService(this.servicename),
      edit: false,
      item: {},
      loading: true
    }
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    // Edit mode
    this.edit = !!this.$route.params.id

    // Load
    this.fetch()
  },
  methods: {
    fetch: function () {
      if (!this.edit) {
        this.setFormLoading(false)
      } else {
        this.service.view(this.$route.params.id)
          .then((response) => {
            this.item = response.data
          })
          .catch(() => {
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn objektbeskrivelse')

            this.onCancel()
          })
          .then(() => {
            this.setFormLoading(false)
          })
      }
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.service.save(this.item.Objektbeskrivelseid, this.item)
              .then((response) => {
                this.$helpers.showSuccessAlert('Objektbeskrivelse er lagret')

                this.item = response.data

                if (!this.edit) {
                  this.$router.go(-1)
                }
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen', 'danger')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    onCancel: function () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerObjektbeskrivelseEdit.vue